@if (tooltip) { @switch (tooltip.type) { @case ('success') {
<span
  class="bi bi-check-circle-fill"
  customTooltip
  [text]="tooltip.text"
  [listData]="tooltip.listData"
></span>
} @case ('error') {
<span
  class="bi bi-exclamation-triangle-fill"
  customTooltip
  [text]="tooltip.text"
  [listData]="tooltip.listData"
></span>
} @default {
<span
  class="bi bi-info-circle-fill"
  [ngStyle]="tooltip.color ? { color: tooltip.color } : {}"
  customTooltip
  [text]="tooltip.text"
  [listData]="tooltip.listData"
></span>
} } }
